import React, { useMemo } from 'react';
import styled from '@emotion/styled';

import Modal from '~/App/Components/Modal';
import { assetUrl } from '~/helpers';
import { isIos } from '~/utils/agent';

export enum MobileAppModalType {
  DownloadApp = 'download_app',
  DesktopLogin = 'desktop_login',
}

export type MobileAppModalProps = {
  onModalClose: () => void;
  isOpen: boolean;
  type: MobileAppModalType;
};

const StyledModal = styled(Modal)`
  width: 332px !important;
  height: 80vh !important;

  > div {
    height: 100%;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 17px;
`;

const DownloadAppImage = styled.img`
  align-self: center;
  width: 212px;
`;

const Title = styled.div`
  margin-top: 18px;
  font-size: 20px;
  text-align: center;
`;

const Subtitle = styled.div`
  text-align: center;
  margin-top: 17px;
`;

const Download = styled.a`
  margin-top: 18px;
  width: 173px;
  height: 40px;
  align-self: center;
`;

const ChromeExtensionLink = styled.a`
  text-decoration: underline;
`;

export default function MobileAppModal({
  isOpen,
  onModalClose,
  type,
}: MobileAppModalProps) {
  const appLink = useMemo(
    () => (isIos() ? process.env.IOS_APP_URL : process.env.ANDROID_APP_URL),
    []
  );

  const BonjoroChromeLink = () => {
    return (
      <ChromeExtensionLink
        href={process.env.CHROME_EXTENSION_URL}
        target='_blank'
      >
        Chrome Extension
      </ChromeExtensionLink>
    );
  };

  const DownloadAppModal = () => {
    return (
      <>
        <DownloadAppImage
          src={assetUrl('assets/images/modals/download_app.png')}
        />
        <Title>Download the app to record on the move.</Title>
        <Download className='btn btn-primary' href={appLink} target='__blank'>
          Download the app
        </Download>
        <Subtitle>
          Also check out <BonjoroChromeLink /> and log on to the desktop
          platform for more
        </Subtitle>
      </>
    );
  };

  const LoginModal = () => {
    return (
      <>
        <DownloadAppImage
          src={assetUrl('assets/images/modals/task_lists.png')}
        />
        <Title>Log in to the desktop to complete your set up</Title>
        <Subtitle>
          While you&apos;re there, check out <BonjoroChromeLink /> screen
          recorder under &apos;Recordings&apos;.
        </Subtitle>
      </>
    );
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onModalClose}
      hideActions
      showCloseButton
    >
      <ContentContainer>
        {type === MobileAppModalType.DownloadApp ? (
          <DownloadAppModal />
        ) : (
          <LoginModal />
        )}
      </ContentContainer>
    </StyledModal>
  );
}
